import { defineMessages } from 'react-intl';

export default defineMessages({
    addNumber: {
        id: '_.modal.id_check_verification.add_number',
        defaultMessage: 'Add a number'
    },
    select: {
        id: '_.modal.id_check_verification.selectPlaceholder',
        defaultMessage: 'Select number'
    }
});
